import React, { useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { FormikButton, FormikGrid, FormikTextField } from '@sierralabs/react-material-ui-formik';
import { useTaskFields } from '@sierralabs/workflow-ui';
import { useUpdateFile } from '../hooks/useUpdateFile';
const DocumentRenameDialog = props => {
    const { file, open, onCancel, onSuccess } = props;
    const { isFolder } = file;
    const onSuccessRef = useRef(onSuccess);
    const formikRef = useRef(null);
    const [error, setError] = useState();
    const { isFieldDisabled } = useTaskFields(file.task, !isFolder);
    const { data, isLoading, error: renameError, updateFile } = useUpdateFile(file.id, isFolder);
    const fileLabelCaps = isFolder ? 'Folder' : 'File';
    useEffect(() => {
        onSuccessRef.current = onSuccess;
    }, [onSuccess]);
    useEffect(() => {
        open && setError(undefined);
    }, [open]);
    useEffect(() => {
        var _a;
        (_a = formikRef.current) === null || _a === void 0 ? void 0 : _a.setSubmitting(isLoading);
    }, [isLoading]);
    useEffect(() => {
        var _a;
        if (data) {
            (_a = onSuccessRef.current) === null || _a === void 0 ? void 0 : _a.call(onSuccessRef, data);
        }
    }, [data]);
    useEffect(() => {
        setError(renameError);
    }, [renameError]);
    return (React.createElement(Dialog, { fullWidth: true, maxWidth: 'xs', open: open, onClose: onCancel },
        React.createElement(Formik, { innerRef: formikRef, initialValues: { name: file.name || '' }, validationSchema: Yup.object({
                name: Yup.string().required('Name is required.')
            }), onSubmit: form => updateFile(form) },
            React.createElement(Form, { autoComplete: 'off' },
                React.createElement(DialogTitle, null,
                    "Rename ",
                    fileLabelCaps),
                React.createElement(DialogContent, null,
                    React.createElement(FormikGrid, null,
                        React.createElement(FormikTextField, { autoFocus: true, type: 'text', name: 'name', label: `${fileLabelCaps} Name`, disabled: isLoading || (!isFolder && isFieldDisabled('name')) })),
                    error && React.createElement(Alert, { severity: 'error' }, error.message)),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { onClick: onCancel }, "Cancel"),
                    React.createElement(FormikButton, null, "Rename"))))));
};
export default DocumentRenameDialog;
//# sourceMappingURL=DocumentRenameDialog.js.map